import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { setInterval } from '@store/overviewDashboard/base/actions';
import { DatePicker } from 'antd';
import { getLocalTime } from './dateUtils';
import { ArrowRightOutlined } from '@ant-design/icons';
import { isEqual } from 'lodash';

const { RangePicker } = DatePicker;

const CustomDateRangePicker = ({
  value,
  setCustomSelected,
  isCustomSelected,
  overviewDate,
  tzOffset,
  containerRef,
}) => {
  const [rangeValue, setRangeValue] = useState([null, null]);
  const dispatch = useDispatch();
  const allowedDateMoment = moment(getLocalTime(overviewDate, tzOffset));

  const onRangeChange = (values: any) => {
    setRangeValue(values);
  };

  const disableDates = (calendarDate) => {
    const calendarDateMoment = moment(calendarDate);
    return (
      moment().isBefore(calendarDateMoment) ||
      calendarDateMoment.isBefore(allowedDateMoment) ||
      calendarDateMoment.isBefore(
        moment().subtract(13, 'months').startOf('day')
      )
    );
  };

  useEffect(() => {
    if (Array.isArray(value)) {
      setRangeValue([value[0], value[1]]);
    }
  }, [value]);

  const onCustomSelection = () => {
    if (rangeValue && !isEqual(value, rangeValue)) {
      const currentInterval = {
        from: moment(rangeValue[0]).startOf('day').format(),
        to: moment(rangeValue[1]).endOf('day').format(),
        shortcut: 'custom',
      };
      dispatch(setInterval({ interval: currentInterval }));
    }
    setCustomSelected(false);
  };

  return (
    <div style={{ width: '240px' }}>
      <RangePicker
        value={rangeValue as any}
        // defaultPickerValue={[moment().add(-1, 'month'), moment()]}
        separator={<ArrowRightOutlined />}
        disabledDate={disableDates}
        allowClear={false}
        onChange={onRangeChange}
        onOpenChange={
          isCustomSelected ? onCustomSelection : () => setCustomSelected(true)
        }
        open={isCustomSelected}
        getPopupContainer={() => containerRef.current} /* tslint:disable-line */
      />
    </div>
  );
};

export default CustomDateRangePicker;
